import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContainerEdit } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm, LabelCabecera, LabelKey, LabelValor } from '../componentes_generales/componentes_formulario/labels/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatearFechaMoment_a_String, formatearNumeroDecimal, completar_String } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso, validarCampoString, validarFechaMomentEnFormatoString, validarJSON } from '../../funciones_globales/utils';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import global_axios from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import { cargar_Factura, inicializarFactura, seleccionar_PuntoFacturacion } from '../../actions/ventas/act_ven02';
import { seleccionar_NumeroComprobante, seleccionar_NumeroComprobanteAlterno } from '../../actions/generales/act_gen04';
import { cargar_NotaCreditoPorCodigo, cargar_NotaCreditoPorNumero, inicializarNotaCredito } from '../../actions/clientes/act_cli04';
import { cargar_NotaDebitoPorCodigo, cargar_NotaDebitoPorNumero, inicializarNotaDebito } from '../../actions/clientes/act_cli05';
import NumeroComprobante from '../componentes_generales/numeroComprobante/numeroComprobante';
import NumeroComprobanteAlterno from '../componentes_generales/numeroComprobante/numeroComprobanteAlterno';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { obtenerSecuencial, obtenerParametros } from '../../funciones_globales/parametros';
import styled from 'styled-components';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';

const ContenedorInfoDocModif = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #cfd8dc;
  padding: 5px;
  margin-bottom: 5px;
`;

const ContenedorBotones = styled.div`
  margin-top: 10px;
`;

const ContenedorDocModif = styled.div`  
  display: ${props => props.isVisible?'block':'none'};
`;

const ContenedorToggle = styled.span`
  margin-left: 15px;
`;

const LabelTieneDocRelacionado = styled.label`
  display: inline;
  font-size: 12px;
  color: green;
`;

class FormCli05 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      secuencialNDebito: '',
      idNotaDebito: '',
      idCliente: null,
      idVendedor: null,
      fechaNotaDebito: null,
      tipo: 'I',
      docModificado: 'F',
      conceptosNDebito: [],
      conceptosNDebitoPorTipo: [],
      idDocModificado: '',
      notaCreditoInterna: '',
      concepto_sel: null,
      observacion: '',
      subtotalGravaIva: null,
      subtotalNoGravaIva: null,
      porcentajeIva: null,
      valorIva: null,
      total: null,
      permitirValorGravaIva: false,
      tieneDocRelacionado: true
    };

    this.handleInputChange=this.handleInputChange.bind(this);
    this.limpiar=this.limpiar.bind(this);
    this.getNotaDebitoById=this.getNotaDebitoById.bind(this);
    this.guardarNotaDebito=this.guardarNotaDebito.bind(this);
    this.getDocumentoAModificar=this.getDocumentoAModificar.bind(this);
    this.calculoValores=this.calculoValores.bind(this);
    this.seleccConceptosNDebitoPorTipo=this.seleccConceptosNDebitoPorTipo.bind(this);
    this.inicializarDocumentos=this.inicializarDocumentos.bind(this);
    this.imprimirNotaDebito=this.imprimirNotaDebito.bind(this);
    this.anularNotaDebito=this.anularNotaDebito.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    if (name==='tipo'){
      this.seleccConceptosNDebitoPorTipo(value);
    }
  }
  
  componentDidMount(){
    Promise.all([
      this.cargarCatalogoConceptosNDebito(),
      obtenerSecuencial('Debito'),
      obtenerParametros('IVAACTUAL'),
      this.props.generar_LogAuditoriaIngresoForm('0105'),
    ])
    .then(([conceptosNotaDebito, secuencialNotaDeb, paramIvaActual]) => {
      let fechaProceso = getFechaProcesoPorModulo('01');

      this.setState({
        conceptosNDebito: conceptosNotaDebito,
        secuencialNDebito: completar_String((secuencialNotaDeb.codigo-1).toString(), '0', 6),
        fechaNotaDebito: moment(fechaProceso, 'DD/MM/YYYY'),
        porcentajeIva: parseFloat(paramIvaActual[0].IvaActual)
      });

      this.seleccConceptosNDebitoPorTipo(this.state.tipo);
      this.props.inicializarFactura();
      this.props.inicializarNotaCredito();
      this.props.inicializarNotaDebito();
    })
    .catch(error => {      
      alert(error.response?error.response.data.msg:error);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0105');
  }

  getOptions_Clientes(input, callback){        
    if (input.toString().length >= 2 ){
        let query = "?cadena_busq=" + input;     
        cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  calculoValores(){    
    let subtotalGravaIva = this.state.subtotalGravaIva===null?0:(this.state.subtotalGravaIva.toString().trim()==='' || isNaN(this.state.subtotalGravaIva)?0:this.state.subtotalGravaIva);
    let subtotalNoGravaIva = this.state.subtotalNoGravaIva===null?0:(this.state.subtotalNoGravaIva.toString().trim() ==='' || isNaN(this.state.subtotalNoGravaIva)?0:this.state.subtotalNoGravaIva);    
    let porcentajeIva = this.state.porcentajeIva===null?0:(isNaN(this.state.porcentajeIva)?0:this.state.porcentajeIva);
    let valorIva = parseFloat(multiplicarDecimales(subtotalGravaIva, (porcentajeIva/100))).toFixed(2);
    let total = parseFloat(parseFloat(subtotalGravaIva)+parseFloat(valorIva)+parseFloat(subtotalNoGravaIva)).toFixed(2);
    this.setState({valorIva, total});
  }

  inicializarPuntoFacturacionDeNumerosComprobantes(){
    let puntoFacturacionDefault;

    for(let i=0; i<this.props.puntosFacturacion.length; i++){
      if (this.props.puntosFacturacion[i].EsDefault==='S'){
          puntoFacturacionDefault = this.props.puntosFacturacion[i];
          break;
      }
    }

    let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
    this.props.seleccionar_NumeroComprobante(numeroComprobante);
    this.props.seleccionar_NumeroComprobanteAlterno(numeroComprobante);
    this.props.seleccionar_PuntoFacturacion(puntoFacturacionDefault.Codigo);
  }

  inicializarDocumentos(inicializaPtoFac){
    this.props.inicializarFactura();
    this.props.inicializarNotaCredito();
    this.props.inicializarNotaDebito();
    if(inicializaPtoFac){
      this.inicializarPuntoFacturacionDeNumerosComprobantes();
    }
    this.setState({notaCreditoInterna: ''});
  }

  limpiar(){
    this.inicializarDocumentos(true);
    Promise.all([
      obtenerSecuencial('Debito')
    ])
    .then(([secuencialNotaDeb])=>{
      let fechaProceso = getFechaProcesoPorModulo('01');
      this.setState({
        operacion: 'G',
        idNotaDebito: '',
        secuencialNDebito: completar_String((secuencialNotaDeb.codigo-1).toString(), '0', 6),
        idCliente: null,
        idVendedor: null,
        fechaNotaDebito: moment(fechaProceso, 'DD/MM/YYYY'),
        tipo: 'I',
        docModificado: 'F',
        idDocModificado: '',
        notaCreditoInterna: '',
        concepto_sel: null,
        observacion: '',
        subtotalGravaIva: null,
        subtotalNoGravaIva: null,
        porcentajeIva: null,
        valorIva: null,
        total: null,
        permitirValorGravaIva: false,
        tieneDocRelacionado: true
      });
      this.seleccConceptosNDebitoPorTipo(this.state.tipo);
    });
  }

  getDocumentoAModificar(){
    
    if(this.state.docModificado==='F'){

      if (!validarCampoString(this.props.numeroComprobante, 17)){
        alert('No ha especificado el No. de Documento a modificar correctamente.');
        return;
      }

      let establec = this.props.numeroComprobante.slice(0,3);
      let ptoEmision = this.props.numeroComprobante.slice(4,7);
      let secuencial = this.props.numeroComprobante.slice(8);

      this.props.cargar_Factura(establec, ptoEmision, secuencial)
      .then(()=>{
        try {
          if (validarJSON(this.props.facturaSel)){
            this.setState({ idDocModificado: this.props.facturaSel.Factura,
                            idCliente: this.props.facturaSel.cli.Codigo,
                            idVendedor: this.props.facturaSel.vend.Codigo,
                            porcentajeIva: this.props.facturaSel.PorcentajeIva});
          } 
        }catch(error){
          alert(`Ocurrió un error al cargar la factura especificada. Error: ${error}`);
        }
      });

    }else{      
      if(this.state.docModificado==='NCSRI'){ // NOTA DE CREDITO SRI
        
        if (!validarCampoString(this.props.numeroComprobante, 17)){
          alert('No ha especificado el No. de Documento a modificar correctamente.');
          return;
        }

        let establec = this.props.numeroComprobante.slice(0,3);
        let ptoEmision = this.props.numeroComprobante.slice(4,7);
        let secuencial = this.props.numeroComprobante.slice(8);

        this.props.cargar_NotaCreditoPorNumero(establec, ptoEmision, secuencial)
        .then(()=>{
          try{
            if (validarJSON(this.props.notaCreditoSel)){
              this.setState({ idDocModificado: this.props.notaCreditoSel.Credito,
                              idCliente: this.props.notaCreditoSel.cli.Codigo,
                              idVendedor: this.props.notaCreditoSel.vend.Codigo,
                              porcentajeIva: this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva});
            }
          }catch (error){
            alert(`Ocurrió un error al cargar la nota de crédito especificada. Error: ${error}`);
          }        
        });
      }else{ // NOTA DE CREDITO INTERNA
        
        if (!validarCampoString(this.state.notaCreditoInterna, 6)){
          alert('No ha especificado el No. de Documento a modificar correctamente.');
          return;
        }

        let idNotaCredito = this.state.notaCreditoInterna;
        this.props.cargar_NotaCreditoPorCodigo(idNotaCredito)
        .then(()=>{
          try{
            if (validarJSON(this.props.notaCreditoSel)){            
              this.setState({  idDocModificado: this.props.notaCreditoSel.Credito,
                                idCliente: this.props.notaCreditoSel.cli.Codigo,
                                idVendedor: this.props.notaCreditoSel.vend.Codigo,
                                porcentajeIva: this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva});
            }
          }catch(error){
            alert(`Ocurrió un error al cargar la nota de crédito especificada. Error: ${error}`);
          }
        });
      }
    }
  }

  getNotaDebitoById(tipoId){
    // Se puede consultar una N/D utilizando el Código (tipoId = 'Id') o el Número (tipoId = 'Nro')
    
    if (tipoId === 'Id'){
      let idNotaDeb = this.state.idNotaDebito;
      if (!validarCampoString(idNotaDeb, 6)){
        alert('No ha especificado el Cód. de Nota de Débito correctamente.');
        return;
      }

      this.props.cargar_NotaDebitoPorCodigo(idNotaDeb)
      .then(()=>{
        try {
          if (validarJSON(this.props.notaDebitoSel)){
            let total = parseFloat(this.props.notaDebitoSel.Valor===null?0:this.props.notaDebitoSel.Valor).toFixed(2);
            let valorIva = parseFloat(this.props.notaDebitoSel.Iva===null?0:this.props.notaDebitoSel.Iva).toFixed(2);
            let totalSinIva = parseFloat(this.props.notaDebitoSel.TotalSinIva===null?0:this.props.notaDebitoSel.TotalSinIva).toFixed(2);
            let totalConIva = parseFloat(total - totalSinIva - valorIva).toFixed(2);
            let porcentajeIva = parseFloat(this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva).toFixed(2);
            let tipoNotaDeb = this.props.notaDebitoSel.EsInterna==='S'?'I':'S';
  
            this.seleccConceptosNDebitoPorTipo(tipoNotaDeb);

            this.setState({
              operacion: 'M',
              fechaNotaDebito: moment(this.props.notaDebitoSel.Fecha, 'DD/MM/YYYY'),
              tipo: tipoNotaDeb,
              concepto_sel: this.props.notaDebitoSel.Tipo,
              docModificado: '',              
              observacion: this.props.notaDebitoSel.Observacion,
              subtotalGravaIva: totalConIva,
              subtotalNoGravaIva: totalSinIva,
              porcentajeIva: porcentajeIva,
              valorIva,
              total
            });
            
            this.props.seleccionar_PuntoFacturacion(this.props.notaDebitoSel.PtoFacturacion);
          }  
        } catch (error) {
          alert(`Ocurrió un error al cargar la nota de débito especificada. Error: ${error}`);
        }
      });

    }else{
      if (!validarCampoString(this.props.numeroNotaDebito, 17)){
        alert('No ha especificado el No. de Nota de Débito correctamente.');
        return;
      }

      let establec = this.props.numeroNotaDebito.slice(0,3);
      let ptoEmision = this.props.numeroNotaDebito.slice(4,7);
      let secuencial = this.props.numeroNotaDebito.slice(8);
      
      this.props.cargar_NotaDebitoPorNumero(establec, ptoEmision, secuencial)
      .then(()=>{
        try {
          if (validarJSON(this.props.notaDebitoSel)){
            let total = parseFloat(this.props.notaDebitoSel.Valor===null?0:this.props.notaDebitoSel.Valor).toFixed(2);
            let valorIva = parseFloat(this.props.notaDebitoSel.Iva===null?0:this.props.notaDebitoSel.Iva).toFixed(2);
            let totalSinIva = parseFloat(this.props.notaDebitoSel.TotalSinIva===null?0:this.props.notaDebitoSel.TotalSinIva).toFixed(2);
            let totalConIva = parseFloat(total - totalSinIva - valorIva).toFixed(2);
            let porcentajeIva = parseFloat(this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva).toFixed(2);
            let tipoNotaDeb = this.props.notaDebitoSel.EsInterna==='S'?'I':'S';
  
            this.seleccConceptosNDebitoPorTipo(tipoNotaDeb);
            
            this.setState({
              operacion: 'M',
              fechaNotaDebito: moment(this.props.notaDebitoSel.Fecha, 'DD/MM/YYYY'),
              tipo: tipoNotaDeb,
              concepto_sel: this.props.notaDebitoSel.Tipo,
              docModificado: '',              
              observacion: this.props.notaDebitoSel.Observacion,
              subtotalGravaIva: totalConIva,
              subtotalNoGravaIva: totalSinIva,
              porcentajeIva: porcentajeIva,
              valorIva,
              total,
              idNotaDebito: this.props.notaDebitoSel.Debito
            });

            this.props.seleccionar_PuntoFacturacion(this.props.notaDebitoSel.PtoFacturacion);
          }  
        } catch (error) {
          alert(`Ocurrió un error al cargar la nota de débito especificada. Error: ${error}`);
        } 
      });
    }  
  }

  cargarCatalogoConceptosNDebito(){
    return new Promise((resolve, reject) => {
      global_axios.get('/catalogos?tipo=otros&opcion=NDCLIENTE')
	    .then((response)=>{
        resolve(response.data);
      })
      .catch((err)=>{
        reject('Error al cargar datos del catálogo de conceptos de Nota de Débito: ' + err);
      });
    });
  }

  guardarNotaDebito(){
    if (this.state.operacion==='M'){
      alert('La modificación de la Nota de Débito no está permitida.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let fechaNotaDebito = formatearFechaMoment_a_String(this.state.fechaNotaDebito);
    if (!validarFechaMomentEnFormatoString(fechaNotaDebito)){
      alert('La fecha de la Nota de Débito es inválida.');
      return;
    }

    if (this.state.concepto_sel===null){
      alert('No ha seleccionado el concepto de la Nota de Débito.');
      return;
    }

    if(this.state.tieneDocRelacionado){
      if((!validarJSON(this.props.facturaSel)) && (!validarJSON(this.props.notaCreditoSel))){
        alert('No ha seleccionado la factura o nota de crédito a modificar.');
        return;
      }
    }

    this.calculoValores();

    if (!this.validarValoresEnNotaDebito()){
      return;
    }

    if(!validarCampoString(this.state.observacion, 1, 120)){
      alert('No ha especificado la observación.');
      return;
    }    

    let fechaProceso = getFechaProcesoPorModulo('01');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaNotaDebito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }
    
    this.props.cambiar_VisualizacionLoading(true);

    let notaDebito = {
      tipo: this.state.concepto_sel,
      fechaNotaDebito: fechaNotaDebito,
      codCliente: this.state.idCliente,
      totalNoGravaIva: (this.state.subtotalNoGravaIva===null?0:(this.state.subtotalNoGravaIva.toString().trim() ==='' || isNaN(Number(this.state.subtotalNoGravaIva))?0:this.state.subtotalNoGravaIva)),
      porcentajeIva: parseFloat(this.state.porcentajeIva),
      valorIva: parseFloat(this.state.valorIva),
      total: parseFloat(this.state.total),
      observacion: this.state.observacion,
      codVendedor: this.state.idVendedor,
      ptoFacturacion: this.state.tipo==='I'?null:this.props.puntoFacturacionSel,
      idFactura: this.state.tieneDocRelacionado?(this.state.docModificado==='F'?this.state.idDocModificado:''):null,
      idNotaCredito: this.state.tieneDocRelacionado?(this.state.docModificado!=='F'?this.state.idDocModificado:''):null,
      moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
      dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
      usuario: getItemDatosSesion('usuario')
    };

    global_axios({
      method: 'POST',
      url: '/notasdebito',
      data: notaDebito
    })
    .then((response)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert('Se generó correctamente la Nota de Débito No.: ' + response.data.nroNotaDebito);
      this.limpiar();
    })
    .catch(error => {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  anularNotaDebito(){
    if(this.state.operacion==='M' && validarJSON(this.props.notaDebitoSel)){
      let idNotaDebito = this.props.notaDebitoSel.Debito;
      let estadoNotaDebito = this.props.notaDebitoSel.Status;

      if(estadoNotaDebito==='A'){
        alert('No puede proceder con la anulación de la Nota de Débito porque está Anulada');
        return;
      }

      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      let anularNotaDeb = window.confirm('¿Está seguro de anular la Nota de Débito?');
      if(!anularNotaDeb){
        return;
      }else{
        this.props.cambiar_VisualizacionLoading(true);
    
        global_axios({
          method: 'DELETE',
          url: `/notasdebito/${idNotaDebito}`,
          headers: {'idregaudit': this.props.idRegAudit}
        })
        .then(()=> {
          this.props.cambiar_VisualizacionLoading(false);      
          alert('La Nota de Débito fue anulada correctamente.');          
          this.limpiar();
        })
        .catch((error)=>{
          this.props.cambiar_VisualizacionLoading(false);
          alert(error.response?error.response.data.msg:error.message);
        });
      }
    }else{
      alert('No ha especificado el número de Nota de Débito a anular.');
    }
  }
  
  seleccConceptosNDebitoPorTipo(tipo){
    let conceptosNDPorTipo = [];
    this.state.conceptosNDebito.forEach((conceptoND)=>{
      if (conceptoND.Tipo === tipo){
        conceptosNDPorTipo.push({
          value: conceptoND.Codigo,
          label: conceptoND.Descripcion + '(' + conceptoND.Codigo + ')'
        });
      }
    });

    this.setState({conceptosNDebitoPorTipo: conceptosNDPorTipo, concepto_sel: null});
  }

  verificarTipoNotaDebitoGravaIva(tipo){    
    this.state.conceptosNDebito.forEach((conceptoND)=>{      
      if (conceptoND.Codigo === tipo){
        if (conceptoND.GravaIva){
          this.setState({ permitirValorGravaIva: true });
        }else{
          this.setState({ permitirValorGravaIva: false });
        }
      }
    });
  }

  validarValoresEnNotaDebito(){
    let valoresOk = true;    
    
    if(this.state.subtotalGravaIva!==null){
      if(this.state.subtotalGravaIva.trim().length!==0){
        if(isNaN(Number(this.state.subtotalGravaIva)) || Number(this.state.subtotalGravaIva)<=0){
          alert('El Subtotal Grava Iva es inválido.');
          valoresOk = false;
        }
      }
    }

    if(valoresOk){
      if(this.state.subtotalNoGravaIva!==null){
        if(this.state.subtotalNoGravaIva.trim().length!==0){
          if(isNaN(Number(this.state.subtotalNoGravaIva)) || Number(this.state.subtotalNoGravaIva)<=0){
            alert('El Subtotal No Grava Iva es inválido.');
            valoresOk = false;
          }
        }
      }
    }

    if(valoresOk){
      if( (this.state.subtotalGravaIva===null?'':this.state.subtotalGravaIva).trim().length===0 &&
          (this.state.subtotalNoGravaIva===null?'':this.state.subtotalNoGravaIva).trim().length===0){
          alert('Debe especificar Subtotal Grava Iva y/o Subtotal No Grava Iva.');
          valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.porcentajeIva))){
        alert('El Porcentaje de Iva es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.valorIva))){
        alert('El Valor de Iva es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.total)) || Number(this.state.total)<=0){
        alert('El Valor Total es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){

      if(this.state.tieneDocRelacionado){
        let total = parseFloat(this.state.total).toFixed(2);
        let saldoDocModif = 0;
        if (this.state.docModificado === 'F'){
          saldoDocModif = parseFloat(this.props.facturaSel.Saldo===null?0:this.props.facturaSel.Saldo).toFixed(2);
        }else{
          saldoDocModif = parseFloat(this.props.notaCreditoSel.Saldo===null?0:this.props.notaCreditoSel.Saldo).toFixed(2);
        }

        if(this.state.docModificado !== 'F'){
          if (parseFloat(total)>parseFloat(saldoDocModif)){
            alert('El valor total de la Nota de Débito no puede ser mayor que el saldo del documento a modificar/relacionar.');
            valoresOk = false;
          }
        }
      }
    }
    return valoresOk;
  }

  imprimirNotaDebito(){
    if (this.state.operacion==='M' && validarJSON(this.props.notaDebitoSel)){
      let idNotaDebito = this.props.notaDebitoSel.Debito;
      
      visualizarReporteEnPdf(`&rpt=72&param1=${idNotaDebito}`);
    }else{
      alert('No ha especificado el número de Nota de Débito a imprimir.');
    }
  }

  render(){

    let tipoDocModif='',
        clienteDocModif='',
        vendedorDocModif='',
        fechaEmiDocModif='',
        valorDocModif='',
        porcIvaDocModif='',
        saldoDocModif='';
    
    let documentoRelacionado = '';
    
    if (this.state.operacion === 'G'){
      if (this.state.docModificado==='F'){
        if (validarJSON(this.props.facturaSel)){
          tipoDocModif='FACTURA';
          clienteDocModif=`${this.props.facturaSel.cli.Codigo} - ${this.props.facturaSel.cli.Nombre}`
          vendedorDocModif=`${this.props.facturaSel.vend.Codigo}  - ${this.props.facturaSel.vend.Nombre}`;
          fechaEmiDocModif=this.props.facturaSel.Fecha;
          valorDocModif=parseFloat(this.props.facturaSel.Importe).toFixed(2).toString();
          porcIvaDocModif=this.props.facturaSel.PorcentajeIva===null?0:this.props.facturaSel.PorcentajeIva;
          saldoDocModif=parseFloat(this.props.facturaSel.Saldo===null?0:this.props.facturaSel.Saldo).toFixed(2).toString();
        }
      }else{
        if (this.state.docModificado==='NCSRI'){      
          if (validarJSON(this.props.notaCreditoSel)){
            tipoDocModif='NOTA DE CRÉDITO SRI';
            clienteDocModif=`${this.props.notaCreditoSel.cli.Codigo} - ${this.props.notaCreditoSel.cli.Nombre}`;
            vendedorDocModif=`${this.props.notaCreditoSel.vend.Codigo} - ${this.props.notaCreditoSel.vend.Nombre}`;
            fechaEmiDocModif=this.props.notaCreditoSel.Fecha;
            valorDocModif=parseFloat(this.props.notaCreditoSel.Valor===null?0:this.props.notaCreditoSel.Valor).toFixed(2).toString();
            porcIvaDocModif=this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva;
            saldoDocModif=parseFloat(this.props.notaCreditoSel.Saldo===null?0:this.props.notaCreditoSel.Saldo).toFixed(2).toString();
          }
        }else{
          if (validarJSON(this.props.notaCreditoSel)){
            tipoDocModif='NOTA DE CRÉDITO INTERNA';
            clienteDocModif=`${this.props.notaCreditoSel.cli.Codigo} - ${this.props.notaCreditoSel.cli.Nombre}`;
            vendedorDocModif=`${this.props.notaCreditoSel.vend.Codigo} - ${this.props.notaCreditoSel.vend.Nombre}`;
            fechaEmiDocModif=this.props.notaCreditoSel.Fecha;
            valorDocModif=parseFloat(this.props.notaCreditoSel.Valor===null?0:this.props.notaCreditoSel.Valor).toFixed(2).toString();
            porcIvaDocModif=this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva;
            saldoDocModif=parseFloat(this.props.notaCreditoSel.Saldo===null?0:this.props.notaCreditoSel.Saldo).toFixed(2).toString();
          }
        }
      }
    }else{
      if(validarJSON(this.props.notaDebitoSel.fact)){
        documentoRelacionado = `Factura: [Cód.: ${this.props.notaDebitoSel.fact.Factura} | Nro.: ${this.props.notaDebitoSel.fact.Establecimiento || ''}-${this.props.notaDebitoSel.fact.PtoEmision || ''}-${this.props.notaDebitoSel.fact.Nro || ''}]`;
      }
      if(validarJSON(this.props.notaDebitoSel.cred)){
        documentoRelacionado = `Nota de Crédito: [Cód.: ${this.props.notaDebitoSel.cred.Credito} | Nro.: ${this.props.notaDebitoSel.cred.Establecimiento || ''}-${this.props.notaDebitoSel.cred.PtoEmision || ''}-${this.props.notaDebitoSel.cred.CreditoSri || ''}]`;
      }
    }

    return(
      <ContenedorForm porc_ancho={82}>
        <HeaderForm>
          <TituloForm>Nota de Débito</TituloForm>
          <LabelCabecera>Últ. Nota Déb.: {this.state.secuencialNDebito}</LabelCabecera>
        </HeaderForm>
        <CuerpoForm>
          <ContainerEdit>
            <Row>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Cód. Nota de Débito:</LabelForm>
                <InputSearch tipoInput='text' nombre='idNotaDebito' placeholder='Cód. Nota de Débito' valor={this.state.idNotaDebito} maxLength={6}
                  func_CambiarValor={this.handleInputChange} func_BuscarValor={()=>{this.getNotaDebitoById('Id')}} func_OnFocus={this.limpiar}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>No. Nota de Débito:</LabelForm>
                <NumeroComprobanteAlterno name='numND' placeholder='No. Nota de Débito' funcBuscarComprobante={()=>{this.getNotaDebitoById('Nro')}}
                  func_OnFocus={this.limpiar}/>
              </ContainerCol>
            </Row>
          </ContainerEdit>
          <Row>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Cód. Nota de Débito:</LabelForm>
              <InputText autoComplete='off' type='text' name='codNotaDebito' value={this.state.idNotaDebito}
                className='form-control input-sm' placeholder='Cód. Nota de Débito' readOnly='true'/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha:</LabelForm>
              <PickerFecha fechaSeleccionada={this.state.fechaNotaDebito} disabled={!(this.props.permiteCambioFProceso==='S')}
                func_onChange={(fecha)=>{this.setState({fechaNotaDebito: fecha})}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Tipo Nota Débito:</LabelForm>
              <LabelForm className='radio-inline'>
                <input type="radio" name="tipo" value="I" checked={this.state.tipo==="I"} onChange={this.handleInputChange}/>
                Interna</LabelForm>
              <LabelForm className='radio-inline'>
                <input type="radio" name="tipo" value="S" checked={this.state.tipo==="S"} onChange={this.handleInputChange}/>
                SRI</LabelForm>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Concepto:</LabelForm>
              <ReactSelect options={ this.state.conceptosNDebitoPorTipo } value={this.state.concepto_sel} 
                func_onChange={(value)=>{ if(Array.isArray(value)){value=null};
                                          let conceptoSel = (value===null)?null:value.value;
                                          if(conceptoSel!==null){
                                            this.verificarTipoNotaDebitoGravaIva(conceptoSel);
                                          }
                                          this.setState({concepto_sel: conceptoSel});
                                        }
                              }/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Pto. Facturación:</LabelForm>
              <PuntoFacturacion disabled={this.state.tipo==='I'}/>
            </ContainerCol>
          </Row>

          <Row isInvisible={this.state.operacion==='M'?true:false} margen_arriba={15}>
            <ContainerCol className='col-sm-12'>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <LabelForm></LabelForm>
                  <LabelTieneDocRelacionado>{(this.state.tieneDocRelacionado?'Con':'Sin') + ' Documento a Modificar/Relacionar' }</LabelTieneDocRelacionado>
                  <ContenedorToggle>
                    <ToggleSwitch
                      checked={this.state.tieneDocRelacionado}
                      onChange={() => {this.setState({ tieneDocRelacionado: !this.state.tieneDocRelacionado })}}
                      size='sm'
                    />
                  </ContenedorToggle>
                </ContainerCol>
              </Row>
              <Row margen_arriba={15} isInvisible={!this.state.tieneDocRelacionado}>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Documento a Modificar/Relacionar:</LabelForm>
                  <div className='radio'>
                    <LabelForm><input type='radio' name="docModificado" value="F" checked={this.state.docModificado==="F"} onChange={this.handleInputChange}/>
                      Factura</LabelForm>
                  </div>
                  <div className='radio'>
                    <LabelForm><input type="radio" name="docModificado" value="NCSRI" checked={this.state.docModificado==="NCSRI"} onChange={this.handleInputChange}/>
                      N. Crédito SRI</LabelForm>
                  </div>
                  <div className='radio'>
                    <LabelForm><input type="radio" name="docModificado" value="NCI" checked={this.state.docModificado==="NCI"} onChange={this.handleInputChange}/>
                      N. Crédito Interna</LabelForm>
                  </div>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>            
                  <LabelForm>Número Documento a Modificar/Relacionar:</LabelForm>
                  <ContenedorDocModif isVisible={this.state.docModificado!=='NCI'?true:false}>
                    <NumeroComprobante placeholder={this.state.docModificado==='F'?'No. Factura':(this.state.docModificado==='NCSRI'?'No. Nota Crédito':'')}
                      funcBuscarComprobante={this.getDocumentoAModificar}
                      func_OnFocus={()=>{this.inicializarDocumentos(false)}}/>
                  </ContenedorDocModif>
                  <ContenedorDocModif isVisible={this.state.docModificado==='NCI'?true:false}>
                    <InputSearch autoComplete='off' tipoInput='text' nombre='notaCreditoInterna' placeholder='Cód. Nota de Crédito' valor={this.state.notaCreditoInterna} maxLength={6}
                      func_CambiarValor={this.handleInputChange} func_BuscarValor={this.getDocumentoAModificar} func_OnFocus={()=>{this.inicializarDocumentos(false)}}/>
                  </ContenedorDocModif>
                </ContainerCol>
                <ContainerCol className='col-sm-7'>
                <LabelForm>Información Documento a Modificar/Relacionar:</LabelForm>
                <ContenedorInfoDocModif className='col-sm-12'>
                  <Row>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Tipo Dcto:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelValor>{tipoDocModif}</LabelValor>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Cliente:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-6'>
                      <LabelValor>{clienteDocModif}</LabelValor>
                    </ContainerCol>
                  </Row>
                  <Row>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>F. Emisión:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelValor>{fechaEmiDocModif}</LabelValor>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Vendedor:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-6'>
                      <LabelValor>{vendedorDocModif}</LabelValor>
                    </ContainerCol>
                  </Row>
                  <Row>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Valor:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelValor>{valorDocModif?formatearNumeroDecimal(valorDocModif):''}</LabelValor>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>% Iva:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelValor>{validarCampoString(porcIvaDocModif,1,2)?porcIvaDocModif+'%':''}</LabelValor>
                    </ContainerCol>                                      
                    <ContainerCol className='col-sm-2'>
                      <LabelForm>Saldo:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                      <LabelValor>{saldoDocModif?formatearNumeroDecimal(saldoDocModif):''}</LabelValor>
                    </ContainerCol>
                  </Row>
                </ContenedorInfoDocModif>
              </ContainerCol>
            </Row>
              <Row margen_arriba={15} isInvisible={this.state.tieneDocRelacionado}>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Cliente:</LabelForm>
                  <ReactSelectAsync value={this.state.idCliente} func_loadOptions={this.getOptions_Clientes}
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({idCliente: value===null?null:value.value});}}/>
                </ContainerCol>
              </Row>
            </ContainerCol>
          </Row>

          <Row isInvisible={this.state.operacion==='M'?false:true} margen_arriba={15}>
            <ContainerCol className='col-sm-2'>
              <LabelKey>Estado:</LabelKey>
              <LabelValor>{validarJSON(this.props.notaDebitoSel.est)?`${this.props.notaDebitoSel.est.Estado} - ${this.props.notaDebitoSel.est.Nombre}`:''}</LabelValor>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelKey>Cliente:</LabelKey>
              <LabelValor>{validarJSON(this.props.notaDebitoSel.cli)?`${this.props.notaDebitoSel.cli.Codigo} - ${this.props.notaDebitoSel.cli.Nombre}`:''}</LabelValor>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelKey>Doc. Relacionado:</LabelKey>
              <LabelValor>{documentoRelacionado}</LabelValor>
            </ContainerCol>            
          </Row>
          <Row margen_arriba={10}>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Subtotal Grava Iva:</LabelForm>
              <InputText type='text' name='subtotalGravaIva' disabled={!this.state.permitirValorGravaIva} value={this.state.subtotalGravaIva===null?'':this.state.subtotalGravaIva} onChange={this.handleInputChange} onBlur={()=>{this.calculoValores();}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Subtotal No Grava Iva:</LabelForm>
              <InputText type='text' name='subtotalNoGravaIva' value={this.state.subtotalNoGravaIva===null?'':this.state.subtotalNoGravaIva} onChange={this.handleInputChange} onBlur={()=>{this.calculoValores();}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <LabelForm>% Iva:</LabelForm>
              <InputText type='text' name='porcentajeIva' value={this.state.porcentajeIva===null?'':this.state.porcentajeIva} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <LabelForm>Valor Iva:</LabelForm>
              <InputText type='text' name='valorIva' value={this.state.valorIva===null?'':this.state.valorIva} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Total:</LabelForm>
              <InputText type='text' name='total' value={this.state.total===null?'':this.state.total} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Observación:</LabelForm>
              <InputText type='text' name='observacion' value={this.state.observacion} onChange={this.handleInputChange}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContenedorBotones className='col-sm-12'>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarNotaDebito}
                  disabled={this.state.operacion==='M'?true:false}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirNotaDebito}><i className='fa fa-print fa-lg'/> Imprimir</button>
                <button type='button' className='btn btn-danger btn-sm' onClick={this.anularNotaDebito}
                  disabled={this.state.operacion==='M'?false:true}><i className='fa fa-minus-circle fa-lg'/> Anular</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </ContenedorBotones>
          </Row>
       
        </CuerpoForm>
      </ContenedorForm>
    )
  }
}

const mapStateToProps = state =>{
  return {  isVisibleLoading: state.ui.isVisibleLoading,           
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            numeroComprobante: state.generales.numComprobSel,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel,
            facturaSel: state.ventas.facturaSel,
            notaCreditoSel: state.clientes.notaCreditoSel,
            notaDebitoSel: state.clientes.notaDebitoSel,
            puntosFacturacion: state.ventas.puntosFact,
            numeroNotaDebito: state.generales.numComprobAlternoSel
  };
};

const mapDispatchToProps = ((dispatch) => {
  return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading,
                              cargar_Factura,
                              cargar_NotaCreditoPorCodigo,
                              cargar_NotaCreditoPorNumero,
                              cargar_NotaDebitoPorCodigo,
                              cargar_NotaDebitoPorNumero,
                              inicializarFactura,
                              inicializarNotaCredito,
                              inicializarNotaDebito,
                              seleccionar_NumeroComprobante,
                              seleccionar_NumeroComprobanteAlterno,
                              seleccionar_PuntoFacturacion
                            }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli05);